import React, { useEffect, useState } from "react";
import "./Subscriptions.scss";
import { Searchbar } from "../../../../components";
import { useSelector } from "react-redux";
import { getPlanDetailsFromPlanID, setAllTransactions } from "../../../../utils/services/user";
import moment from "moment";
import { Dialog } from "@mui/material";
import { ConfirmationDialog } from "../../../../dialogs";
import { normalizeTimestamp } from "../../../../utils/services/other";

function Subscriptions(): JSX.Element {
  const otherDataStore = useSelector((store: any) => store?.otherData);
  const [currentItems, setCurrentItems] = useState<any[]>([]);
  const [orignalItems, setOrignalItems] = useState<any[]>([]);
  const [isConfirmationDialog, setConfirmationDialog] = useState<boolean>(false)
  const [selectedPlan, setSelectedPlan] = useState<any>(null)

  useEffect(() => {
    let isMounted = true;
    isMounted &&
      (async () => {
        let allTransactions = await setAllTransactions();
        let activeSubscription = allTransactions.filter((transaction:any) => transaction.planID !== transaction.subscriptionID);
        setCurrentItems(activeSubscription);
        setOrignalItems(activeSubscription);
      })();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="Subscriptions">
      <div className="Subscriptions__FilterBar">
        <div className="searchBar">
          <Searchbar
            orignalItems={orignalItems}
            setCurrentItems={setCurrentItems}
            placeholder={"Search Subscription ID / Amount"}
            primaryConditionKey={"subscriptionID"}
            secondaryConditionKey={"amount"}
          />
        </div>
      </div>
      <div className="Subscriptions__TableBox">
        {
          orignalItems?.length > 0 ? <table>
            <thead>
              <tr className="tableHead">
                <th>Subscription ID</th>
                {!otherDataStore?.isMobile ? (
                  <>
                    <th>Plan</th>
                    <th>Next Billing</th>
                    <th>Amount</th>
                  </>
                ) : (
                  <>
                  </>
                )}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((item, index) => (
                <tr key={index}>
                  <td>{item?.subscriptionID}</td>
                  <td>{getPlanDetailsFromPlanID(item?.planID)?.title}</td>
                  <td> {moment(normalizeTimestamp(item?.createdAt)).add(1, 'years').format("DD-MM-YYYY")}</td>
                  <td>{'$ ' + item?.amount}</td>
                  <td>
                    <button className="fillBtn__blue"
                      style={{ margin: 0, padding: "10px", fontSize: '0.9rem', fontWeight: 'normal' }} onClick={()=>{setConfirmationDialog(true); setSelectedPlan(item)}}>Cancel Subscription</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table> : <>

          <p style={{fontStyle:'italic', color:'grey'}}>No Active Subscriptions</p>

          </>
        }

      </div>
      <Dialog
        open={isConfirmationDialog}
        onClose={() => {setConfirmationDialog(false)}}
      >
        <ConfirmationDialog setConfirmationDialog={setConfirmationDialog} selectedPlan={selectedPlan} />
      </Dialog>
    </div>

  );
}

export default Subscriptions;
